/**
 * Keep in sync with `SHORT_DATE_DAYS` in libs/common (order-utils).
 * Warehouse cannot import @monrepo-build/common.
 */
export const SHORT_DATE_DAYS = 180;

export function isShortDatedExpiration(expiration, now = new Date()) {
  if (expiration == null || expiration === '') return false;
  const expDate = new Date(expiration);
  if (Number.isNaN(expDate.getTime())) return false;
  const sixMonthsFromNow = new Date(
    now.getTime() + SHORT_DATE_DAYS * 24 * 60 * 60 * 1000
  );
  return expDate >= now && expDate <= sixMonthsFromNow;
}
